module.exports = __webpack_public_path__ + "img/common-file-text-alternate.9409bd96.svg";